import { RetirementFilesPage } from "@/features/retirement/pages/RetirementFiles";
import React from "react";

const RetirementFiles = () => {
  return <RetirementFilesPage />;
};

export default RetirementFiles;
